module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/03_shape-sm-f4494d60dbc43aba9a8dad47b1c1ec97.png";